import React from 'react';
import styles from './Styles.jsx';
import {
  // Button,
  Container,
  // Divider,
  Grid,
  Header,
  // Icon,
  Image,
  // List,
  // Menu,
  Segment
  // Visibility,
} from 'semantic-ui-react';

const PARTNERS = [
  // {img:'mts.png'},
  { img: 'tele2.svg' },
  { img: 'william-lawsons.png' },
  { img: 'volkswagen.png' },
  { img: 'parliament.png' },
  { img: 'universal-music.png' },
  { img: 'fight-nights-alt.png' },
  { img: 'aeroflot.png' },
  { img: 'skoda-v.png' }
];

const Partners = () => (
  <section id='partners'>
    <Segment style={styles.section}>
      <Container>
        <Header as='h1' style={styles.h}>
          Our Partners
        </Header>

        <Grid verticalAlign='middle' centered doubling columns={4}>
          {PARTNERS.map((p, i) => (
            <Grid.Column key={i}>
              <Image src={'img/partners/' + p.img} className='partners-logo' />
            </Grid.Column>
          ))}
        </Grid>
      </Container>
    </Segment>
  </section>
);

export default Partners;



// WEBPACK FOOTER //
// ./src/components/Partners.jsx